import { DeviceIdProvider } from '@database/workspace';
import { ErrorCodes, FileModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { IImportHandler } from '../import-handler.interface';

export class RegistrationHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private loggingService: LoggingService,
		private deviceIdProvider: DeviceIdProvider
	) {}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		await this.configHeader(model);
		// await this.deviceId(model);

		if (this.next) {
			await this.next.handle(model);
		}
	}

	private async configHeader(model: FileModel): Promise<void> {
		try {
			if (model.FusionConfigHeader.length > 1) {
				throw new Error('Config header has more than one object.');
			}
		} catch (error) {
			this.loggingService.error(ErrorCodes.RegistrationConfigHeaderError, error);
			throw error;
		}
	}

	// private async deviceId(model: FileModel): Promise<void> {
	// 	try {
	// 		const storedDeviceId: string = await this.deviceIdProvider.getDeviceId();
	// 		model.FusionConfigHeader[0].device_id = storedDeviceId;
	// 	} catch (error) {
	// 		this.loggingService.error(ErrorCodes.RegistrationDeviceIdError, error);
	// 		throw error;
	// 	}
	// }
}
